
import { selectLangObj } from '../../../reducers/langReducer.js';
import { useDispatch, useSelector } from 'react-redux';

function FamilyDetails({ details }) {

  const langObj = useSelector(selectLangObj);




  return (

    <div className='p-5   flex flex-col gap-3 items-start '>

      {details?.slava && (
        <div>
          {langObj["Slava"]} : {details.slava}
        </div>
      )}

      {details?.haplogrupa && (
        <div>
          {langObj["Haplogroup"]} : {details.haplogrupa}
        </div>
      )}


      {details?.rod && (
        <div>
          {langObj["Genus"]} : {details.rod}
        </div>
      )}
    </div>

  );
}

export default FamilyDetails;
